module.exports = __webpack_public_path__ + "static/media/STAFFING_SOLUTION.256bb11a.jpg";